import './App.css';
import Intro from '././components/Intro/Intro'
import Header from '././components/Header/Header'

function App() {
  return (
    <div className="App">
      <Header/>
      <Intro/>
    </div>
  );
}

export default App;
